import { Divider } from '@mui/material'
import React, { FC } from 'react'

type Props = {
  label: string
}

const ModuleDivider: FC<Props> = ({ label }) => (
  <Divider
    textAlign="center"
    sx={(theme) => ({
      color: theme.palette.darkGrey,
      fontSize: 12,
      fontWeight: 400,
      px: 1,
      '&::before, &::after': { borderColor: theme.palette.mediumGrey },
    })}
  >
    {label}
  </Divider>
)

export default ModuleDivider
